import { type UseMutationResult, useMutation } from '@tanstack/react-query'
import { saveInboundAttachments, scanInboundInvoice, uploadInboundFile } from './apis'
import type { InboundAttachmentSaveReq, InboundAttachmentSaveRes, InboundScanReq, InboundScanRes } from './types'

/** 입고작업 2.0 mutation key — 조회 쿼리는 없다(스캔도 쓰기 커맨드라 POST mutation). */
export const inboundWorkQueryKeys = {
  all: ['GLOBAL_INBOUND_WORK'] as const,
  scan: () => [...inboundWorkQueryKeys.all, 'SCAN'] as const,
  upload: () => [...inboundWorkQueryKeys.all, 'UPLOAD'] as const,
  saveAttachments: () => [...inboundWorkQueryKeys.all, 'SAVE_ATTACHMENTS'] as const,
}

/** 스캔 — 응답 본문(ApiResponseV2.data)이 비면 null 로 돌려준다(1.0 '스캔 응답이 비어 있습니다.' 분기). */
export const useScanInboundInvoice = (): UseMutationResult<InboundScanRes | null, Error, InboundScanReq> =>
  useMutation({
    mutationKey: inboundWorkQueryKeys.scan(),
    mutationFn: async (body) => (await scanInboundInvoice(body))?.data ?? null,
  })

export interface InboundUploadInput {
  file: Blob
  fileName: string
}

/** 첨부 하나 업로드 → S3 key. 종류(사진·영상)는 완료 API 에 key 와 함께 넘기므로 업로드에는 필요 없다. 여러 건은 호출부가 건마다 부른다(하나가 실패해도 나머지는 계속). */
export const useUploadInboundFile = (): UseMutationResult<string, Error, InboundUploadInput> =>
  useMutation({
    mutationKey: inboundWorkQueryKeys.upload(),
    mutationFn: ({ file, fileName }) => uploadInboundFile(file, fileName),
  })

/** 첨부 완료(파일 정보 생성 + 원본송장 이력 FILE_ID 에 덧붙임). */
export const useSaveInboundAttachments = (): UseMutationResult<InboundAttachmentSaveRes, Error, InboundAttachmentSaveReq> =>
  useMutation({
    mutationKey: inboundWorkQueryKeys.saveAttachments(),
    mutationFn: async (body) => (await saveInboundAttachments(body)).data,
  })
